import { useContext } from 'react'
import CreateCancel from '../../components/forms/CreateCancel'
import Tabel from '../../components/tabel/Tabel'
import DashboardContext from '../../Context'
import FormBusinessToBusinessNotification from './FormBusinessToBusinessNotification'
export default function BusinessToBusinessNotification() {

    const { SohwaddFrom } = useContext(DashboardContext)

    return (
        <>
            <CreateCancel />
            {
                SohwaddFrom ?
                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '15px' }} >

                        <FormBusinessToBusinessNotification />
                    </div>
                    :
                    <Tabel />
            }
        </>
    )
}